import React, { useState } from "react";

// Newsletter signup. Validates locally; wiring to a mailing-list provider is
// still pending, so submissions are not yet transmitted.
export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("");
  const [invalid, setInvalid] = useState(false);

  const submit = (e) => {
    e.preventDefault();
    const valid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
    if (!valid) {
      setInvalid(true);
      setStatus("Please enter a valid email address.");
      return;
    }
    setInvalid(false);
    setStatus("Thanks for joining the good-mood list!");
    setEmail("");
  };

  return (
    <form className="ro-newsletter" onSubmit={submit} noValidate>
      <h3>Join our good-mood list!</h3>
      <p>Café news, new cravings and little reasons to drop by.</p>
      <label className="ro-newsletter__label" htmlFor="ro-newsletter-email">
        Email Address
      </label>
      <div className="ro-newsletter__row">
        <input
          id="ro-newsletter-email"
          type="email"
          placeholder="Enter your email"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-invalid={invalid}
          aria-describedby="ro-newsletter-status"
          required
        />
        <button type="submit" aria-label="Join the newsletter">
          →
        </button>
      </div>
      <p id="ro-newsletter-status" className="ro-newsletter__status" role="status" aria-live="polite">
        {status}
      </p>
    </form>
  );
}
